import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { tap, catchError, finalize } from 'rxjs/operators';
import { BehaviorSubject, throwError } from 'rxjs';
import * as moment from 'moment';
import {
	WeeklyJobShiftsResult,
	Job,
	JobsClient,
	LookupClient,
} from 'src/shared/api';
import { jobsFragments } from '../../jobs.routes';
import { LocalStorageService } from 'src/shared/local-storage.service';
import { dateParamFormat } from 'src/shared/constants';

export enum JobScheduleDialogContext {
	jobsCalendar = 'jobsCalendar',
	scheduleRWIC = 'scheduleRWIC',
	missingDWR = 'missingDWR',
	jobSetup = 'jobSetup',
}
export interface JobScheduleDialogData {
	weeklyJobShiftsResult: WeeklyJobShiftsResult;
	context: JobScheduleDialogContext[];
	startDate: moment.Moment;
}

@Component({
	selector: 'rpfsa-job-schedule-dialog',
	templateUrl: './job-schedule-dialog.component.html',
	styleUrls: ['./job-schedule-dialog.component.scss'],
})
export class JobScheduleDialogComponent implements OnInit {
	private loadingSubject = new BehaviorSubject<boolean>(false);
	job: Job;
	contexts: JobScheduleDialogContext[];
	loading$ = this.loadingSubject.asObservable();
	jobsFragments = jobsFragments;

	constructor(
		private jobsClient: JobsClient,
		private lookupClient: LookupClient,
		private localStorageService: LocalStorageService,
		@Inject(MAT_DIALOG_DATA) private data: JobScheduleDialogData
	) {}

	ngOnInit() {
		if (!this.data || !this.data.weeklyJobShiftsResult) {
			throw Error(
				'Job not provided to dialog or variable name has changed.'
			);
		}
		this.getJob(this.data.weeklyJobShiftsResult.job.id);

		if (!this.data || !this.data.context) {
			throw Error('Context of job details not provided.');
		}
		this.contexts = this.data.context;
		this.lookupClient.getFieldWorkerTypes().subscribe((r) => {
			this.localStorageService.set('fieldWorkerTypes', r);
		});
	}

	getJob(jobId: number) {
		this.jobsClient
			.getJob(jobId)
			.pipe(
				tap(() => {
					this.loadingSubject.next(true);
				}),
				catchError((err) => {
					this.loadingSubject.next(false);
					return throwError(err);
				}),
				finalize(() => this.loadingSubject.next(false))
			)
			.subscribe((jobResponse) => {
				this.job = jobResponse;
			});
	}

	get startDate() {
		return moment.utc(this.data.startDate).format(dateParamFormat);
	}
	// goToJob(id: number) {
	//   this.selfDialogRef.close();
	//   this.router.navigate(routePathFrags.job({ id: id }));
	// }
	// scheduleRWIC(id: number) {
	//   this.selfDialogRef.close();
	//   this.router.navigate(routePathFrags.scheduleRWIC({ id: id }))
	// }
}
